var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkDotThreeV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.445 5.82195C14.445 6.07746 14.3948 6.33047 14.2971 6.56656C14.1994 6.80265 14.0562 7.01718 13.8755 7.1979C13.6949 7.37863 13.4805 7.52201 13.2445 7.61986C13.0084 7.71772 12.7555 7.76812 12.5 7.7682C12.2445 7.76829 11.9914 7.71804 11.7554 7.62034C11.5193 7.52264 11.3047 7.3794 11.124 7.19879C10.9433 7.01818 10.7999 6.80374 10.7021 6.56771C10.6042 6.33169 10.5538 6.07871 10.5537 5.8232C10.5535 5.30719 10.7584 4.81225 11.1231 4.44726C11.4879 4.08226 11.9827 3.87712 12.4987 3.87695C13.0147 3.87679 13.5097 4.08161 13.8747 4.44637C14.2397 4.81113 14.4448 5.30594 14.445 5.82195Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 14.4444C13.5744 14.4444 14.4452 13.5736 14.4452 12.4994C14.4452 11.4253 13.5744 10.5544 12.5002 10.5544C11.426 10.5544 10.5552 11.4253 10.5552 12.4994C10.5552 13.5736 11.426 14.4444 12.5002 14.4444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 21.1232C13.5744 21.1232 14.4452 20.2523 14.4452 19.1782C14.4452 18.104 13.5744 17.2332 12.5002 17.2332C11.426 17.2332 10.5552 18.104 10.5552 19.1782C10.5552 20.2523 11.426 21.1232 12.5002 21.1232Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkDotThreeV);
export default __webpack_public_path__ + "static/media/MarkDotThreeV.f67f65b5be493fc0342a06657e68ee13.svg";
export { ForwardRef as ReactComponent };